import React from 'react'

import { ButtonContainer, Page, PageContent } from 'common'
import { Header } from 'components'
import { Button } from 'common/styles/layouts'

import { ServiceResponseView } from './ServiceResponseView'
import { useServiceResponse } from '../hooks/useServiceResponse'

export function ServiceResponse() {
  const {
    pageTitle,
    understandButtonLabel,
    response,
    aditionalInfo,
    isResponseError,
    hasScroll,
    ref,
    isActive,
    onClick,
    onError,
  } = useServiceResponse()

  if (isResponseError || !isActive) {
    onError()
  }

  return (
    <Page>
      <Header title={pageTitle ?? ''} />
      <PageContent ref={ref}>
        <ServiceResponseView response={response} aditionalInfo={aditionalInfo} />
        <ButtonContainer $hasScroll={hasScroll}>
          <Button fullWidth onClick={onClick}>
            {understandButtonLabel}
          </Button>
        </ButtonContainer>
      </PageContent>
    </Page>
  )
}
